module.exports = __webpack_public_path__ + "img/flover-yellow.272e266.png";